import requestDefault from '@/shared/utils/request';
import { GetPackageDetailParamType, PackageBuyStatusEnum, PreCreateRightRequestType } from '../types';

/** f.marketing.rights.order.preCreate(创建预支付订单接口)
 * https://yapi.hellobike.cn/project/7020/interface/api/331845
*/
export const preCreateRightOrder = (params: PreCreateRightRequestType):
Promise<{orderId: string}> => requestDefault.postGate(
  'f.marketing.rights.order.preCreate',
  { ...params },
);

/** f.marketing.rights.order.preCreate(创建预支付订单接口)
 * https://yapi.hellobike.cn/project/7020/interface/api/331845
*/
export const queryBuyStatus = (params: GetPackageDetailParamType):
Promise<{packageBuyStatus: PackageBuyStatusEnum}> => requestDefault.postGate(
  'f.marketing.rights.package.queryBuyStatus',
  { ...params },
);

/** f.marketing.rights.order.proxy.pay.failure.count(我的页面查询划扣支付失败订单数量)
 * https://yapi.hellobike.cn/project/7020/interface/api/331729
*/
export const queryOrderToPay = ():
Promise<number> => requestDefault.postGate(
  'f.marketing.rights.order.proxy.pay.failure.count',
);
